import Vue from 'vue';
import searchStore from '../store/search';

let keys = {
    query: 'q',
    category: 'c',
    attributes: 'a',
    page: 'p',
    sort: 's',
    priceRangeMin: 'min',
    priceRangeMax: 'max',
};

const search = {
    basePath: '/search/',
    merchantMap: {},
    silent: false,
    explode(search) {
        let finalParams = {};
        let latestKey = Object.keys(keys)[0];
        let latestAttrKey = '';
        let categoriesUrls;

        let searchParams = search.split('/');
        searchParams.forEach(value => {
            if (Object.values(keys).indexOf(value) != -1 && finalParams[latestKey] !== '') {
                value = Object.keys(keys)[Object.values(keys).indexOf(value)];
                latestKey = value;
                if (latestKey == 'attributes') {
                    finalParams[value] = {};
                } else if (latestKey == 'category') {
                    categoriesUrls = [];
                } else {
                    finalParams[value] = '';
                }
            } else {
                if (finalParams[latestKey] === '') {
                    finalParams[latestKey] = value;
                } else {
                    if (latestKey == 'attributes') {
                        if (Vue.$store.getters['SearchFilters/isSearchableAttribute'](value)) {
                            latestAttrKey = value;
                        }

                        if (latestAttrKey !== '') {
                            if (finalParams[latestKey][latestAttrKey] == undefined) {
                                finalParams[latestKey][latestAttrKey] = [];
                            } else {
                                finalParams[latestKey][latestAttrKey].push(value);
                            }
                        }
                    } else if (latestKey == 'category') {
                        categoriesUrls.push(value);
                    }
                }
            }
        });

        if (Array.isArray(categoriesUrls) && categoriesUrls.length > 0) {
            let categories = Vue.$store.getters['SearchFilters/getCategoriesTreeIds'](categoriesUrls);
            if (categories.activeCategory != undefined) {
                finalParams.category = categories.activeCategory;
                finalParams.categoriesTree = categories.tree;
            }
        }

        return finalParams;
    },
    implode(finalParams, strict = true) {
        let searchParams = [];
        let activeKey = Object.keys(keys)[0];
        for (let finalParam of Object.keys(finalParams)) {
            if (keys.hasOwnProperty(finalParam) || strict !== true) {
                let value = finalParams[finalParam];
                if (keys.hasOwnProperty(finalParam)) {
                    activeKey = finalParam;
                    finalParam = keys[finalParam];
                }
                if (value) {
                    if (typeof value == 'object') {
                        let stringVal = this.implode(value, false);
                        if (stringVal != '') {
                            if (!Array.isArray(finalParams)) {
                                searchParams.push(finalParam);
                            }
                            searchParams.push(stringVal);
                        }
                    } else {
                        if (activeKey == 'category') {
                            value = Vue.$store.getters['SearchFilters/getNestedCategoriesUrl'](value);
                        }
                        if (!Array.isArray(finalParams)) {
                            searchParams.push(finalParam);
                        }
                        searchParams.push(value);
                    }
                }
            }
        }

        return searchParams.join('/');
    },
    merge(target, source) {
        let result = Object.assign({}, target);
        for (const key of Object.keys(source)) {
            let val = source[key];
            if (result.hasOwnProperty(key) && Array.isArray(result[key]) && Array.isArray(val)) {
                Array.prototype.push.apply(result[key], val);
                let unique = [];
                unique = result[key].filter(function(value, index, self) {
                    return self.indexOf(value) === index;
                });
                result[key] = unique;
            } else if (
                target.hasOwnProperty(key) &&
                typeof target[key] == 'object' &&
                (typeof val == 'object' && val)
            ) {
                result[key] = this.merge(target[key], val);
            } else {
                result[key] = val;
            }
        }

        return result;
    },
    initRoute(to, from, next) {
        if (
            to.name == 'merchant-search' &&
            from.name != undefined &&
            from.name != 'merchant-search' &&
            from.name != 'default'
        ) {
            location.reload();
        }
        if (to.params.merchantUrl && this.merchantMap[to.params.merchantUrl]) {
            to.params.merchant = this.merchantMap[to.params.merchantUrl];
        }
        if (to.params['search'] != undefined) {
            let finalParams = this.explode(to.params['search']);
            Object.assign(to.params, finalParams);
        }

        next();
    },
    buildSearchParams(additionalParams = {}, reset = false) {
        let finalParams = {};
        if (reset !== true) {
            finalParams = Object.assign({}, Vue.$router.currentRoute.params);
        }
        finalParams.merchantUrl = Vue.$router.currentRoute.params.merchantUrl;
        finalParams.merchant = Vue.$router.currentRoute.params.merchant;
        finalParams = this.merge(finalParams, additionalParams);

        let result = this.implode(finalParams);

        let prefix = '/';
        if (this.basePath != undefined) {
            prefix = this.basePath;
        }

        let merchantUrl = '';
        if (finalParams.merchantUrl) {
            merchantUrl = '/' + finalParams.merchantUrl;
        }
        if (!result) {
            result = 'q';
        }
        return merchantUrl + prefix + result;
    },
    getSearchRouteParams(additionalParams, isPage = false, isSort = false) {
        if (isPage !== true) {
            additionalParams.page = null;
        }
        if (isSort !== true) {
            additionalParams.sort = null;
        }

        return this.buildSearchParams(additionalParams);
    },
    setMerchant(merchantId) {
        Vue.$router.merchantId = merchantId;
    },
    unsetMerchant() {
        Vue.$router.currentRoute.params.merchantUrl = null;
        Vue.$router.currentRoute.params.merchant = null;
    },
};

export default {
    install(Vue, options) {
        Vue.prototype.$search = search;
        Vue.$search = search;

        if (!Vue.$store.state['SearchResults']) {
            Vue.$store.registerModule('SearchResults', searchStore);
        }

        Vue.filter('striphtml', function(value) {
            var div = document.createElement('div');
            div.innerHTML = value;
            var text = div.textContent || div.innerText || '';
            return text;
        });

        Vue.filter('clearLineBreaks', function(value) {
            return value.replace(/(\r\n|\n|\r)/gm," ");
        });

        Vue.filter('clearExtraSpaces', function(value) {
            return value.replace(/ {1,}/g," ");
        });

        Vue.$store.commit('SearchResults/SET_GRID_CLASSES', options.searchResultGridClasses);

        Vue.$router.onReady(() => {
            if (Vue.$router.merchantId && !Vue.$router.currentRoute.meta.isSearchRoute) {
                let path = Vue.$router.currentRoute.path.replace('/', '');
                let params = path.split('/');
                if (params[0]) {
                    Vue.$router.currentRoute.params.merchantUrl = params[0];
                }
            }
            const merchantUrl = Vue.$router.currentRoute.params.merchantUrl;
            if (merchantUrl) {
                Vue.$search.merchantMap[merchantUrl] = Vue.$router.merchantId;
                Vue.$router.currentRoute.params.merchant = Vue.$search.merchantMap[merchantUrl];
            }
        });
    },
};
